<template lang="pug">
  b-container
    b-form-row.align-items-center.mt-3.mb-4
      b-col.mb-2.mb-md-0
        h4.mb-0 Nueva plantilla
    b-form-group(label="Nombre de plantilla")
      b-input-group(:append="`${message_template.name.length}/512`")
        b-form-input(placeholder="Nombre de plantilla", :value="message_template.name", @input="message_template.name = $event.toLowerCase().replace(/ /g,'_')", maxlength="512", :state="message_template.name ? null : (validated ? false : null)")
    b-form-row.mb-3
      b-col
        b-form-group(label="Categoría", :state="message_template.category ? null : (validated ? false : null)", invalid-feedback="Selecciona una categoría")
          k-select.disabled-white(placeholder="- Categoría -", :options="categories_options", v-model="message_template.category")
      b-col
        b-form-group(label="Idioma", :state="message_template.language ? null : (validated ? false : null)", invalid-feedback="Selecciona un idioma")
          k-select.disabled-white(placeholder="- Idioma -", :options="languages", v-model="message_template.language")
    b-row.mb-3(no-gutters)
      b-col
        b-card.shadow.mb-0.h-100(no-body)
          b-card-header
            h5 Cabecera
            b-form-row
              b-col(cols="auto")
                b-form-select(v-model="header.format", @change="header.text = header_example_text = ''; header_example_file = null")
                  option(v-for="format in header_formats", :key="format.id", :value="format.id") {{format.label}}
              b-col(v-if="header.format === 'TEXT'")
                b-form-group
                  b-input-group(:append="`${header.text.length}/60`")
                    b-form-input(placeholder="Cabecera de mensaje", :value="header.text", maxlength="60", @input="validateHeader", :state="header.text ? null : (validated ? false : null)")
                b-form-group(label="Ejemplo para variable de cabecera", label-size="sm", v-if="header_var")
                  b-form-input(size="sm", :placeholder="`Valor de {{${header_var[0]}}}`", v-model="header_example_text", :state="header_example_text ? null : (validated ? false : null)")
              b-col(v-else-if="header.format")
                b-form-group
                  template(#description, v-if="header_example_file")
                    b-link.text-sm.text-danger(@click="header_example_file = null") Quitar
                  b-form-file(:placeholder="`Selecciona ${header_file_config[header.format].placeholder} de ejemplo`", v-model="header_example_file", :disabled="uploading", :accept="header_file_config[header.format].accept", browse-text="Seleccionar")
          b-card-body
            b-form-row.mb-2.align-items-center
              b-col
                h5.mb-0 Texto
              b-col(cols="auto")
                b-button#emoji-icon(variant="light", size="sm")
                  smile-icon.icon-md
              b-col(cols="auto", v-for="editor in text_editors", :key="editor.name")
                b-button(variant="light", size="sm", @click="addSpecialText(editor.char)")
                  v-icon(:name="editor.name")
              b-col(cols="auto")
                b-button(variant="light", size="sm", @click="addVariable", v-html="'{{n}}'")
            b-form-group.mb-0(:description="`${message_template.body.length}/1024`" )
              b-form-textarea#body_input(placeholder="Cuerpo del mensaje", v-model="message_template.body",  maxlength="1024", :state="message_template.body ? null : (validated ? false : null)")
            b-link(v-b-toggle="'message_vars_section'", v-if="body_vars && body_vars.length")
              small Variables del mensaje
              chevron-down-icon.ml-1.icon-sm
            b-collapse.mt-2(id="message_vars_section", :visible="!!body_vars.length")
              b-form-group(v-for="(vars, index) in body_vars", :key="index")
                b-form-input(:placeholder="`Valor para {{${vars}}}`", size="sm", v-model="body_example[index]", :state="body_example[index] ? null : (validated ? false : null)")
          b-card-footer
            h5 Pie de página
            b-input-group(:append="`${footer.length}/60`")
              b-form-input(placeholder="Pie de página de mensaje", :value="footer", maxlength="60", @input="footer = $event.replace(/\{\{.[0-9]+\}\}/g, '')")
          b-card-footer
            h5 Botones
            b-form-row.mb-3
              b-col(cols="auto")
                b-form-select(v-model="buttons_type", @change="addButton(true)")
                  option(v-for="btn in button_types", :key="btn.id", :value="btn.id") {{btn.label}}
            b-form-row.mb-3(v-for="(button, index) in buttons", :key="index")
              b-col(cols="4", v-if="button.type !== 'QUICK_REPLY'")
                b-form-group(label="Acción", label-size="sm")
                  b-form-select(size="sm", v-model="button.type")
                    option(v-for="act in action_types", :key="act.id", :value="act.id", :disabled="buttons.length >= 2") {{act.label}}
              b-col(cols="4", v-if="button.type === 'PHONE_NUMBER'")
                b-form-group(label="Teléfono", label-size="sm")
                  b-input-group(size="sm", :append="`${button.phone_number.length}/20`")
                    b-form-input(placeholder="Teléfono", v-model="button.phone_number", maxlength="20", :state="button.phone_number ? null : (validated ? false : null)")
              b-col(cols="4", v-if="button.type === 'URL'" )
                b-form-group(label="URL", label-size="sm")
                  b-input-group(size="sm", :append="`${button.url.length}/2000`")
                    b-form-input(placeholder="URL", :value="button.url", maxlength="2000", @input="validateButtonUrl($event, button)", :state="button.url ? null : (validated ? false : null)")
                b-form-group(label="Ejemplo de variable en URL", label-size="sm", description="Utiliza el dominio más la variable", v-if="buttonUrlVar(button)")
                  b-form-input(size="sm", :placeholder="`https://website.com/{{${buttonUrlVar(button)[0]}}}`", v-model="button_example_url", :state="button_example_url ? null : (validated ? false : null)")
              b-col
                b-form-group(label="Texto del botón", label-size="sm")
                  b-input-group(size="sm")
                    b-form-input(placeholder="Texto", :value="button.text", maxlength="25", :state="button.text ? null : (validated ? false : null)", @input="button.text = $event.replace(/\{\{.[0-9]+\}\}/g, '')")
                    b-input-group-append
                      b-input-group-text {{button.text.length}}/25
                    b-input-group-append
                      b-button(variant="soft-danger", @click="removeButton(index)")
                        trash-2-icon.icon-sm
            b-button(variant="soft-primary", @click="addButton(false)", :disabled="buttons.length == buttons_limit", v-if="buttons_type") Agregar botón
      b-col.pl-3(md="4")
        MessageTemplatePreview(v-bind="preview_data")
    b-row.pb-4.justify-content-center
      b-col(cols="10")
        b-button(variant="primary", block, size="xl", :disable="loading", @click="saveData") Guardar
    //input(type="file", accept="image/*", style="display:none;", ref="input_image", @change="imageSelected")
    b-popover(:show.sync="show_emojis", target="emoji-icon", placement="top", triggers="click")
      template(slot="title")
        .d-flex.align-items-center.justify-content-between
          span Insertar emoji
          x-icon.icon-md.hover-danger.pointer(@click="show_emojis = false")
      picker.w-100.border-0(set="facebook", :style="{height: '250px'}", v-bind="pickerParams", @select="insertEmoji", :data="emojiIndex", title="Emojis", :i18n="i18n")
</template>

<script>
import Select from '@/components/Select.vue'
import MessageTemplatePreview from "./MessageTemplatePreview";
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
import { wrapEmoji } from '@/helpers/emojiParser'
import data from 'emoji-mart-vue-fast/data/facebook.json'
import {mapActions} from 'vuex'
import { UploadFile } from '@/helpers/upload-file'
let emojiIndex = new EmojiIndex(data)

export default {
  data () {
    return {
      loading: false,
      uploading: false,
      validated: false,
      show_emojis: false,
      emojiIndex: emojiIndex,
      pickerParams: {
        showSearch: false,
        showCategories: false,
        showPreview: false
      },
      i18n: {
        search: 'Buscar',
        notfound: 'No hay resultados',
        categories: {
          search: 'Búsqueda',
          recent: 'Usados frecuentemente',
          people: 'Caras y personas',
          nature: 'Naturaleza',
          foods: 'Comida y bebidas',
          activity: 'Actividades',
          places: 'Lugares y viajes',
          objects: 'Objetos',
          symbols: 'Símbolos',
          flags: 'Banderas',
          custom: 'Custom',
        }
      },
      message_template: {
        name: "",
        category: null,
        language: null,
        body: ""
      },
      header_formats: [
        { id: null, label: "Ninguno"},
        { id: "TEXT", label: "Texto"},
        { id: "IMAGE", label: "Imagen"},
        { id: "DOCUMENT", label: "Documento"},
        { id: "VIDEO", label: "Video"},
      ],
      header_file_config: {
        IMAGE: {accept: 'image/*', placeholder: 'imagen'},
        DOCUMENT: {accept: '.pdf', placeholder: 'documento'},
        VIDEO: {accept: '.mp4', placeholder: 'video'},
      },
      button_types: [
        { id: null, label: "Ninguno"},
        { id: "QUICK_REPLY", label: "Botón de respuesta rápida"},
        { id: "CALL_TO_ACTION", label: "Ejecutar Acción"},
      ],
      action_types: [
        { id: "PHONE_NUMBER", label: "Llamar a número"},
        { id: "URL", label: "Ir a sitio web"},
      ],
      text_editors: [
        { char: "*", name: "bold"},
        { char: "_", name: "italic"},
        { char: "~", name: "strikethrough"},
        //{ char: "```", name: "code"},
      ],
      header: {
        format: null,
        text: ""
      },
      header_example_text: '',
      header_example_file: null,
      header_file: null,
      footer: "",
      buttons_type: null,
      button_example_url: '',
      buttons: [],
      body_example: [],
      regex: /(?<=\{\{)\d+?(?=\}\})/g
    }
  },
  props: {
    waba_id: {
      type: String,
      default: ""
    },
    categories_options: {
      type: Array,
      default: () => {
        return []
      }
    },
    languages: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  computed: {
    buttons_limit () {
      return this.buttons_type === 'QUICK_REPLY' ? 3 : 2
    },
    header_var () {
      return this.header.text.match(this.regex)
    },
    body_vars () {
      let match = this.message_template.body.match(this.regex)
      return match ? match.filter((value, index, self) => self.indexOf(value) === index) : []
    },
    preview_data () {
      return {
        header: this.header,
        header_example_text: this.header_example_text,
        header_example_file: this.header_example_file,
        body_message: this.message_template.body,
        body_example: this.body_example,
        footer: this.footer,
        buttons: this.buttons
      }
    }
  },
  methods: {
    ...mapActions(['message_template/create', 'whatsapp/upload_file','helpers/upload_file']),
    async saveData () {

      for(let key in this.message_template) {
        if(!this.message_template[key]) {
          this.validated = true
          return
        }
      }

      for (let i = 0; i < this.body_vars.length; i++) {
        if(!this.body_example[i]) {
          this.validated = true
          return
        }
      }

      if(this.header.format === 'TEXT' && !this.header.text) {
        this.validated = true
        return
      }

      for (let button of this.buttons) {
        if(!button.text) {
          this.validated = true
          return
        }
        if(button.type === "PHONE_NUMBER") {
          if(!button.phone_number) {
            this.validated = true
            return
          }
          delete button.url
        }
        else if (button.type === "URL") {
          if(!button.url) {
            this.validated = true
            return
          }
          if(this.buttonUrlVar(button) && !this.button_example_url) {
            this.validated = true
            return
          }
          delete button.phone_number
        }
      }

      if(this.header_example_text) {
        this.header.example = {
          header_text: [this.header_example_text]
        }
      }

      if(this.header_example_file) {
        try {
          let handle = await this.getFileHandle(this.header_example_file)
          if(handle) {
            this.header.example = {
              header_handle: [handle]
            }
          } else {
            this.$message.warning('No logramos subir el archivo, por favor comprueba tu conexión a internet')
            return
          }
        } catch (e) {
          console.log(e)
          this.$message.warning('No logramos subir el archivo, por favor comprueba tu conexión a internet')
          return
        }
      }

      this.createTemplate()
    },
    async uploadDefaultFile (file) {
      const{header_example_file,message_template} = this
      const extension = file.name.split('.').pop()
      const fileTemplateName = message_template.name.replace(/ /g, '_')
      const params = {
        filename: `${fileTemplateName}_WA_TEMPLATE.${extension}`,
        extension
      }
      return await UploadFile.call(this, header_example_file, params)
    },
    async createTemplate () {
      this.loading = true
      let self = this
      const{ header_example_file, message_template, button_example_url} = this
      let defaultUrl;
      if(header_example_file)defaultUrl = await this.uploadDefaultFile(this.header_example_file)
      if(button_example_url) {
        this.buttons.forEach(el => {
          if(el.type === "URL") {
            el.example = [button_example_url]
          }
        })
      }
      this['message_template/create']({
        waba_id: this.waba_id,
        ...message_template,
        body_example: this.body_example,
        header: this.header,
        footer: this.footer,
        buttons: this.buttons,
        defaultUrl,
        callback: res => {
          self.loading = false
          if (res.error) return self.$message.error(res.error)
          self.$message.success('Plantilla creada')
          self.$emit('close')
        }
      });
    },
    getFileHandle (file) {
      let self = this
      return new Promise(resolve => {
        let form = new FormData()
        form.append('file', file)
        this['whatsapp/upload_file']({
          waba_id: this.waba_id,
          form: form,
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
              return resolve(false)
            } else {
              return resolve(res.resource)
            }
          }
        });
      })
    },
    updateTemplate () {

    },
    addButton (clear = false) {
      if(clear) this.buttons = []
      switch (this.buttons_type) {
        case 'QUICK_REPLY':
          this.buttons.push({type:"QUICK_REPLY", text: ""})
          break
        case 'CALL_TO_ACTION':
          let btn = {type:"PHONE_NUMBER", text: "", url: "",  phone_number: "" }
          let is_phone_number = this.buttons.find(el => el.type === "PHONE_NUMBER")
          if(is_phone_number){
            btn.type = "URL"
          }
          this.buttons.push(btn)
          break
        default:
          this.buttons = []
          break
      }
      this.validated = false
    },
    removeButton (index) {
      this.buttons.splice(index, 1)
    },
    validateHeader (event) {
      let index = 0
      this.header.text = event.replace(/(?<=\{\{)\d+?(?=\}\})/g, match => ++index >= 2 ? '' : match).replace(/\{\{\}\}/g, "")
    },
    validateButtonUrl (event, button) {
      let index = 0
      button.url = event.replace(/(?<=\{\{)\d+?(?=\}\})/g, match => ++index >= 2 ? '' : match).replace(/\{\{\}\}/g, '')
    },
    addSpecialText (char) {
      let el = document.getElementById("body_input")
      if(el.selectionStart === el.selectionEnd) {
        this.message_template.body += `${char}${char}`
        return
      }
      try{
        let message = this.message_template.body
        message = message.slice(0, el.selectionStart) + char + message.slice(el.selectionStart);
        this.message_template.body = message.slice(0, el.selectionEnd + 1) + char + message.slice(el.selectionEnd + 1);
      }catch(e){
        console.log("ERROR ADDING SPECIAL TEXT", e)
      }

    },
    addVariable () {
      let max = 1
      if(this.body_vars.length) {
        max += Math.max.apply(null, this.body_vars)
      }
      this.message_template.body += `{{${max}}}`
    },
    insertEmoji (emoji) {
      this.message_template.body += emoji.native
    },
    buttonUrlVar (button) {
      const match =  button.url.match(this.regex)
      if(!match) this.button_example_url = ''
      return match
    }
  },
  components: { 'k-select': Select, MessageTemplatePreview, Picker },
}
</script>

<style lang="scss">

</style>
